setTimeout(() => {

  let buttonQuickView = document.querySelectorAll('[bss-b2b-btn-quickview]')
  if (buttonQuickView.length) {
       buttonQuickView.forEach((e) => {
        e.addEventListener("click", function(e) {
            setTimeout(async () => {
                document.dispatchEvent(new Event(`bss_b2b:QuickviewLoaded`))
            }, 1000)
        });
    })
  }
}, 2500)